import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'filterControls',
})
export class FilterControlsPipe implements PipeTransform {
  transform(
    controls :AbstractControl[],
    fields ?:string[],
    searchString ?:string,
  ) :AbstractControl[] {
    if (searchString && fields?.length) {
      return controls.filter((control :AbstractControl) => {
        let matched :boolean = false;
        for (let i = 0; i < fields.length; i++) {
          const field = fields[i];
          if (
            control.value[field].toLowerCase().includes(searchString.toLowerCase())
          ) {
            matched = true;
            break;
          }
        }

        return matched;
      });
    }

    return controls;
  }
}
